import Plyr from 'plyr';

export default function initPlayer() {
  const player = new Plyr('#player', {
    muted: true,
    autoplay: true,
    controls: [],
    settings: [],
    loop: { active: true },
  });
}